export const menuItems = [
    {
        id: 1,
        label: "menu.dashboard.text",
        icon: "ri-dashboard-2-line",
        link: "/",
        permCode: "dashboard.get",
        subItems: [
            {
                id: 1,
                label: "overview_static.overview",
                link: "/welcome",
                parentId: 1,
                permCode: "dashboard.cloud"
            },
            {
                id: 2,
                label: "overview_static.dashboard",
                link: "/fullIndex?path=0",
                parentId: 1,
                permCode: "dashboard.overview"
            },
            {
                id: 3,
                label: "overview_static.device",
                link: "/fullIndex?path=1",
                parentId: 1,
                permCode: "dashboard.device"
            },
            {
                id: 4,
                label:"overview_static.work_order",
                link: "/fullIndex?path=2",
                parentId: 1,
                permCode: "dashboard.order"
            },
            {
                id: 5,
                label:"overview_static.business_opportunity",
                link: "/fullIndex?path=3",
                parentId: 1,
                permCode: "dashboard.bo"
            },
        ]
    },
    {
        id: 2,
        label: "menu.after-sales_service.text",
        icon: "ri-service-line",
        permCode: "",
        subItems: [
            {
                id: 6,
                label: "menu.after-sales_service.service_request",
                link: "/repair-request/list",
                parentId: 2,
                permCode: "service.get"
            },
            {
                id: 7,
                label: "menu.after-sales_service.order.text",
                link: "/work-order",
                parentId: 2,
                permCode: "order.get",
            },
            {
                id: 8,
                label: "menu.after-sales_service.report",
                link: "/service-report",
                parentId: 2,
                permCode: "report.get"
            },
            {
                id: 9,
                label: "menu.after-sales_service.business-opportunity",
                link: "/business-opportunity",
                parentId: 2,
                permCode: "business-opportunity.get"
            },
            {
                id: 10,
                label: "menu.after-sales_service.maintenance-plan",
                link: "/maintenance-plan",
                parentId: 2,
                permCode: "maintenance-plan.get"
            },
            {
                id: 11,
                label: "Auditing",
                link: "/auditing-order",
                parentId: 2,
                permCode: "auditing.get"
            }
        ]
    },
    {
        id: 3,
        label: "menu.equipment-management.text",
        icon: "ri-cpu-line",
        permCode: "",
        subItems: [
            {
                id: 9,
                label: "menu.equipment-management.model-management.model",
                link: "/model",
                parentId: 3,
                permCode: "model.get"
            },
            {
                id: 10,
                label: "menu.equipment-management.equipment",
                link: "/equipment-management",
                parentId: 3,
                permCode: "device.get"
            }
        ]
    },
    {
        id: 4,
        label: "menu.intelligent-operation-maintenance.text",
        icon: "icon-smart-op",
        permCode: "",
        subItems: [
            {
                id: 11,
                label: "menu.intelligent-operation-maintenance.health-monitor",
                link: "/iot/health-monitor",
                parentId: 4,
                permCode: "iot.health.monitor"
            },
            {
                id: 12,
                label: "menu.intelligent-operation-maintenance.event",
                link: "/iot/event-management",
                parentId: 4,
                permCode: "iot.event.management"
            },
            {
                id: 13,
                label: "menu.intelligent-operation-maintenance.data-analysis",
                link: "/iot/atlas-analysis",
                parentId: 4,
                permCode: "iot.data.analysis"
            },
            {
                id: 14,
                label: "menu.intelligent-operation-maintenance.expert-service",
                link: "/iot/expert-system",
                parentId: 4,
                permCode: "iot.expert.service"
            },
        ]
    },
    {
        id: 5,
        label: "menu.business-partner.text",
        icon: "ri-group-2-line",
        permCode: "",
        subItems: [
            {
                id: 15,
                label: "menu.business-partner.manufacturer",
                link: "/manufacturer",
                parentId: 5,
                permCode: "manufacturer.get"
            },
            {
                id: 16,
                label: "menu.business-partner.service-company",
                link: "/service-company",
                parentId: 5,
                permCode: "company.get"
            },
            {
                id: 17,
                label: "menu.business-partner.customer",
                link: "/customer",
                parentId: 5,
                permCode: "customer.get"
            }
        ]
    },
    {
        id: 6,
        label: "menu.system-management.text",
        icon: "ri-settings-5-line",
        permCode: "",
        subItems: [
            {
                id: 18,
                label: "menu.system-management.role-management",
                link: "/role-management",
                parentId: 6,
                permCode: "management.role.post"
            },
            {
                id: 18,
                label: "menu.system-management.user-management",
                link: "/user-account-management",
                parentId: 6,
                permCode: "management.user.get"
            },
        ]
    },
]
